import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

import Login from "./pages/Login";
import Layout from "./components/Layout";

import AdminDashboard from "./pages/admin/Dashboard";
import Karyawan from "./pages/admin/Karyawan";
import Divisi from "./pages/admin/Divisi";
import Jabatan from "./pages/admin/Jabatan";
import Gaji from "./pages/admin/Gaji";
import Tunjangan from "./pages/admin/Tunjangan";
import PoinKinerja from "./pages/admin/PoinKinerja";
import IzinAdmin from "./pages/admin/IzinAdmin";
import Absensi from "./pages/admin/Absensi";
import Shift from "./pages/admin/Shift";
import AturShift from "./pages/admin/AturShift";
import Kontrak from "./pages/admin/Kontrak";
import ProjectPayment from "./pages/admin/ProjectPayment";
import PaymentDeveloper from "./pages/admin/PaymentDeveloper";
import PaymentDesigner from "./pages/admin/PaymentDesigner";
import PaymentListing from "./pages/admin/PaymentListing";
import Payroll from "./pages/admin/Payroll";
import ArusKas from "./pages/admin/ArusKas";
import Hutang from "./pages/admin/Hutang";
import Kasbon from "./pages/admin/Kasbon";
import Laporan from "./pages/admin/Laporan";
import LaporanPembuatanWeb from "./pages/admin/LaporanPembuatanWeb";
import UserManagement from "./pages/admin/UserManagement";

import EmployeeDashboard from "./pages/employee/Dashboard";
import AbsensiSaya from "./pages/employee/AbsensiSaya";
import IzinSaya from "./pages/employee/IzinSaya";
import AjukanIzin from "./pages/employee/AjukanIzin";
import PoinSaya from "./pages/employee/PoinSaya";
import JadwalShift from "./pages/employee/JadwalShift";
import SlipGajiSaya from "./pages/employee/SlipGajiSaya";
import Profil from "./pages/employee/Profil";
import KontrakSaya from "./pages/employee/KontrakSaya";
import KoperasiSaya from "./pages/employee/Koperasi";

import ClientDashboard from "./pages/client/Dashboard";
import ClientProfile from "./pages/client/Profile";
import ClientNotifikasi from "./pages/client/Notifikasi";
import ClientTabungan from "./pages/client/Tabungan";
import Kopi from "./pages/admin/Koperasi";
import VendorMobileApiDocs from "./pages/admin/VendorMobileApiDocs";
import VendorDashboard from "./pages/vendor/Dashboard";
import VendorProfile from "./pages/vendor/Profile";
import Pendapatan from "./pages/employee/Pendapatan";
import { roleHomePath } from "./lib/roleHomePath";

function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: 40, textAlign: "center" }}>Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return <Navigate to={roleHomePath(user)} replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              path="/admin"
              element={
                <ProtectedRoute role="admin">
                  <Layout role="admin" />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="karyawan" element={<Karyawan />} />
              <Route path="divisi" element={<Divisi />} />
              <Route path="jabatan" element={<Jabatan />} />
              <Route path="gaji" element={<Gaji />} />
              <Route path="tunjangan" element={<Tunjangan />} />
              <Route path="poin" element={<PoinKinerja />} />
              <Route path="izin" element={<IzinAdmin />} />
              <Route path="absensi" element={<Absensi />} />
              <Route path="shift" element={<Shift />} />
              <Route path="atur-shift" element={<AturShift />} />
              <Route path="kontrak" element={<Kontrak />} />
              <Route path="project-payment" element={<ProjectPayment />} />
              <Route path="list-client" element={<PaymentDeveloper />} />
              <Route path="payment-developer" element={<PaymentDeveloper />} />
              <Route path="payment-designer" element={<PaymentDesigner />} />
              <Route path="payment-listing" element={<PaymentListing />} />
              <Route path="payroll" element={<Payroll />} />
              <Route path="keuangan" element={<ArusKas />} />
              <Route path="hutang" element={<Hutang />} />
              <Route path="kasbon" element={<Kasbon />} />
              <Route path="laporan" element={<Laporan />} />
              <Route path="laporan-pembuatan-web" element={<LaporanPembuatanWeb />} />
              <Route path="users" element={<UserManagement />} />
              <Route path="koperasi" element={<Kopi />} />
              <Route path="vendor-mobile-api-docs" element={<VendorMobileApiDocs />} />
            </Route>

            <Route
              path="/karyawan"
              element={
                <ProtectedRoute role="karyawan">
                  <Layout role="karyawan" />
                </ProtectedRoute>
              }
            >
              <Route index element={<EmployeeDashboard />} />
              <Route path="absensi" element={<AbsensiSaya />} />
              <Route path="izin" element={<IzinSaya />} />
              <Route path="ajukan-izin" element={<AjukanIzin />} />
              <Route path="poin" element={<PoinSaya />} />
              <Route path="shift" element={<JadwalShift />} />
              <Route path="slip-gaji" element={<SlipGajiSaya />} />
              <Route path="kontrak" element={<KontrakSaya />} />
              <Route path="koperasi" element={<KoperasiSaya />} />
              <Route path="pendapatan" element={<Pendapatan />} />
              <Route path="profil" element={<Profil />} />
            </Route>

            <Route
              path="/client"
              element={
                <ProtectedRoute role="client">
                  <Layout role="client" />
                </ProtectedRoute>
              }
            >
              <Route index element={<ClientDashboard />} />
              {/* "Project Group" — hanya muncul di sidebar untuk akun yang tertaut Client
                  individu SEKALIGUS Group Client (lihat buildClientTree di Layout.jsx). Route
                  terpisah dari index supaya scope group selalu eksplisit, tidak bergantung pada
                  urutan prioritas default _client_project_filter. */}
              <Route path="group" element={<ClientDashboard forceScope="group" />} />
              <Route path="notifikasi" element={<ClientNotifikasi />} />
              <Route path="tabungan" element={<ClientTabungan />} />
              <Route path="profile" element={<ClientProfile />} />
            </Route>

            <Route
              path="/vendor"
              element={
                <ProtectedRoute role="vendor">
                  <Layout role="vendor" />
                </ProtectedRoute>
              }
            >
              <Route index element={<VendorDashboard />} />
              <Route path="profile" element={<VendorProfile />} />
            </Route>

            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route
              path="/docs/vendor-mobile-api"
              element={
                <div style={{ padding: 20, background: "#ECE9D8", minHeight: "100vh", boxSizing: "border-box" }}>
                  <VendorMobileApiDocs />
                </div>
              }
            />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
